import createAnimationWrapper from "./createAnimationWrapper";

const anim = ({x=1,y=1}) => ({
  "0%": { transform: "scale(1,1)" },
  "100%": { transform: `scale(${x}, ${y})` }
});

const Base = createAnimationWrapper(anim, {
  duration: "1s",
  easing: "steps(1)",
  fillMode: "forwards",
});

const Flip = ({horizontal, vertical, ...props}) => <Base animation={anim({x: horizontal ? -1 : 1,y: vertical ? -1 : 1})} {...props} />;

export default Flip;
